import {useState} from 'react'
import './forms.css'
import {auth} from '../../providers/firebase'
import {useNavigate, Link} from 'react-router-dom'
import {createUserWithEmailAndPassword, sendEmailVerification} from 'firebase/auth'
import {useAuthValue} from '../../providers/AuthContext'
import { Button, Input, Message } from 'semantic-ui-react';
import logo from "../layout/logo.png";

function Register() {

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const {setTimeActive} = useAuthValue()

  const validatePassword = () => {
    let isValid = true
    if (password !== '' && confirmPassword !== ''){
      if (password !== confirmPassword) {
        isValid = false
        setError('Passwörter stimmen nicht überein')
      }
    }
    return isValid
  }

  const register = e => {
    e.preventDefault()
    setError('')
    if(validatePassword()) {
      // Create a new user with email and password using firebase
        createUserWithEmailAndPassword(auth, email, password)
        .then(() => {
          sendEmailVerification(auth.currentUser)   
          .then(() => {
            setTimeActive(true)
            navigate('/verify-email')
          }).catch((err) => alert(err.message))
        })
        .catch(err => setError(err.message))
    }
    setEmail('')
    setPassword('')
    setConfirmPassword('')
  }

  return (
    <div className="loader">
    <div className='center'>
      <div className='auth'>
      <img src={logo} alt="Logo" width="70%" />
        <hr/>
        {error ? <Message color='red'>{error}</Message> : <div><br/></div>}
        <form onSubmit={register} name='registration_form'>
          <Input
            icon='at'
            iconPosition='left' 
            type='email' 
            value={email}
            placeholder="E-Mail angeben"
            required
            onChange={e => setEmail(e.target.value)}/>

          <Input 
            icon='key'
            iconPosition='left'
            type='password'
            value={password} 
            required
            placeholder='Passwort wählen'
            onChange={e => setPassword(e.target.value)}/>

            <Input 
            icon='key'
            iconPosition='left'
            type='password'
            value={confirmPassword} 
            required
            placeholder='Passwort wiederholen'
            onChange={e => setConfirmPassword(e.target.value)}/>

          <Button type='submit'>Konto erstellen</Button>
        </form>
        <span>
          <Link to="/login"><Button primary>Login</Button></Link>
        </span>
      </div>
    </div>
    </div>
  )
}

export default Register